import React from 'react';
import './index.css';
import './component/customCSS/Main.css'
import ReactDOM from 'react-dom';
import App from './App';
import { BrowserRouter} from 'react-router-dom';
import * as swr from './serviceWorkerRegistration'
import {UserContextProvider} from './store/UserContext'
import './component/customCSS/Shapes.css'





ReactDOM.render(   
<UserContextProvider>
<BrowserRouter> <App /></BrowserRouter>
</UserContextProvider>

,
    document.getElementById('root')
);

swr.register();